// Nearest parent when the hub is opened unscoped, or cold-opened.
export const NEXT_STEPS_CHOOSER_PATH = '/courses';

/**
 * Where the Notes Hub's back button should land on a COLD open.
 *
 * A warm back pops the real view stack, so this is only consulted when nothing
 * is stacked behind the hub (deep link, notification, refresh). CoursesHeader
 * carries `?lesson=` when the hub is opened from a reader, which is enough to
 * rebuild that lesson's own route — the program slug comes off the lesson
 * record, since the query only carries the lesson.
 *
 * Falls back to the part chooser whenever the hub isn't scoped to a real
 * lesson: no `?lesson=`, the no-lesson bucket, or a slug no loaded record
 * matches (a stale link, or lessons not fetched yet).
 *
 * @param {string|undefined} lessonSlug - the `?lesson=` query value
 * @param {Array<{id: string, programSlug?: string}>} lessons - loaded lesson records
 * @param {string} noLessonSlug - the sentinel id of the "no lesson" bucket
 * @returns {string} a route path
 */
export function notesHubBackHref(lessonSlug, lessons, noLessonSlug) {
  if (!lessonSlug || lessonSlug === noLessonSlug) return NEXT_STEPS_CHOOSER_PATH;
  const lesson = (lessons || []).find(l => l?.id === lessonSlug);
  if (!lesson?.programSlug) return NEXT_STEPS_CHOOSER_PATH;
  return `/courses/${lesson.programSlug}/${lessonSlug}`;
}
